import AvatareHistory from "../../components/AvatareHistory/history";
import { TopBar } from "../../components/CommonComponent/Topbar";

export default function HistoryScreen() {

return (
<div>
      <TopBar text="History" />
      <div className="py-8 px-8">
        <div className="p-4 bg-white">
          <AvatareHistory />
        </div>
      </div>
    </div>
)
}